import { client } from '../config/sanityClient';
import { Schema } from '../typings/sanityTypes';

export interface Category {
  value: string;
  color: `#${string}`;
  id: string;
}

const type: Schema = 'category';

export const getCategories = async () => {
  const query = `*[_type == "${type}"]{
        'id': _id,
        'color': color.hex,
        value
    }`;
  const category: Category[] = await client.fetch(query);

  return category;
};
